import { defineStore } from 'pinia'
import Vue from 'vue'

export const useSystemBetStore = defineStore('betslipSystemBet', {
  state: () => ({
    systemStakeMap: {}
  }),
  getters: {
    systemStakeList: (state) => Object.values(state.systemStakeMap),
    systemTotalOddsList() {
      return this.systemStakeList.map((x) => x.totalOdds)
    },
    systemTotalStake() {
      return this.systemStakeList.reduce((sum, bet) => sum + bet.stake * bet.betCount, 0)
    }
  },
  actions: {
    // all multiples 面板 stake 缓存
    updateSystemStake({ stake, id, count, betCount = 1, toReturn = [], valid, bonus, totalOdds = [] }) {
      const bet = { id, stake, betCount, count, toReturn, valid, bonus, totalOdds }
      Vue.set(this.systemStakeMap, id, bet)
    },

    removeSystemStake(id) {
      Vue.delete(this.systemStakeMap, id)
    }
  }
})
